import { inject, Injectable } from '@angular/core';
import { DataContextService, ResultWrapper } from '@seahorse/common';
import { ObjectDefinitionModel } from '@seahorse/domain';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ObjectDefinitionsDataService {
  private _dataContext = inject(DataContextService);

  getByOrganization(
    id: string
  ): Observable<ResultWrapper<ObjectDefinitionModel[]>> {
    return this._dataContext.get<ObjectDefinitionModel[]>(
      `customdata/objectdefinitions/organizationId/${id}`
    );
  }
}
